import { useState, useEffect, useContext } from 'react';
import api from './api/axiosInstance.js';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { UserContext } from './UserContext';
import { Form, Image, Container, Row, Col, Button, Card } from 'react-bootstrap';
import Sidebar from './Sidebar.js';
import CompanyAddGeneral from './CompanyAddGeneral';
import CompanyAddAbout from './CompanyAddAbout';
import CompanyAddLegal from './CompanyAddLegal';
import CompanyAddSize from './CompanyAddSize';
import CompanyAddIndustries from './CompanyAddIndustries';
import CompanyAddFortune from './CompanyAddFortune';
import CompanyAddBusinessType from './CompanyAddBusinessType';
import NavTabs from './NavTabs';
import { Modal } from 'react-bootstrap'; // Import Modal component
import CompanyStats from './CompanyStats';
import Breadcrumb from './Breadcrumb';
import { isAdminType} from './utils/roleUtils';
import icSucess from './assets/img/ic-celebration-circle.svg';
import Alert from 'react-bootstrap/Alert';
import { exportCompanyPdf } from './api/exportCompanyPdf.js';

const EditCompanyGeneral = () => {
    const { id, cityId } = useParams();
    const location = useLocation();
    const { user } = useContext(UserContext);
    const [isEditing, setIsEditing] = useState(false);

    const [generalData, setGeneralData] = useState({
        logo: '',
        logoPreview: '',
        title: '',
        bestPlacetoWorkRating: '',
        accessLevel: '',
        url: '',
        bestPlacetoWorkDescription: '',
    });
    const [aboutData, setAboutData] = useState({
        address: '',
        address2: '',
        country: '',
        country2: '',
        city: '',
        city2: '',
        cityRegion: '',
        zip: '',
        zip2: '',
        otherInformation: '',
        otherInformation2: '',
        phone: '',
        phone2: '',
        childUrl: '',
        childUrl2: '',
        latitude: '', 
        longitude: '',
        latitude2: '', 
        longitude2: '',
        logo: '',
    });
    const [legalData, setLegalData] = useState({
        legalName: '',
        vat: '',
        duns: '',
        globalUltimate: ''
    });
    const [sizeData, setSizeData] = useState({
        globalSize: '',
        localSize: '',
        rating: '',
        ratingSource: '',
    });
    const [industriesData, setIndustriesData] = useState({
        industries: [
            { industry: '', subIndustry: '', subIndustry2: [] }, 
        ],
    });
    const [businessTypeData, setBusinessTypeData] = useState({
        businessPurpose: '',
        localActivities: '',
        localStaffing: '',
        businessTypeOther: '',
    });
    const [fortuneData, setFortuneData] = useState({
        isFortune: false,
        fortuneRank: '',
        fortuneYear: '',
        fortuneRevenue: '',
        fortunePercentChange: '',
        fortuneProfit: '',
    });
    const [showAddress2, setShowAddress2] = useState(false);
    
    const [errors, setErrors] = useState({});
    const [logo, setLogo] = useState(null); // Store the logo file
    const navigate = useNavigate();
    const [activityStatus, setActivityStatus] = useState(true);
    const [showDeleteModal, setShowDeleteModal] = useState(false); // Delete modal state
    const [showStatusModal, setShowStatusModal] = useState(false);
    const [statusMessage, setStatusMessage] = useState('');
    const [showSavedModal, setShowSavedModal] = useState(false);
    const [savedModalTitle, setSavedModalTitle] = useState('Update successful');
    const [savedModalMessage, setSavedModalMessage] = useState('General company information was updated successfully.');

    const [logoPreview, setLogoPreview] = useState(''); // what’s shown as preview
    const [originalLogoUrl, setOriginalLogoUrl] = useState(''); // saved in DB
    const [forceRerenderKey, setForceRerenderKey] = useState(0);
    const [validationAttempted, setValidationAttempted] = useState(false);
    const [showErrorMessage, setShowErrorMessage] = useState(false);

    const [cityName, setCityName] = useState('');
    useEffect(() => {
        if (!cityId) return;
        api.get(`/api/cities/${cityId}`)
            .then(res => setCityName(res.data?.name || ''))
            .catch(err => console.error('Error fetching city for breadcrumb:', err));
    }, [cityId]);

    const cityBasePath = cityId
        ? location.pathname.includes('/city-edit-companies/')
            ? `/city-edit-companies/${cityId}/company/:id`
            : `/city-edit-jobs/${cityId}/company/:id`
        : null;
    const companyNavItems = cityBasePath
        ? [
            { to: cityBasePath, eventKey: 'companyInfo', label: 'Company Info', end: true },
            { to: `${cityBasePath}/hiring`, eventKey: 'hiringInfo', label: 'Hiring Info' },
            { to: `${cityBasePath}/users`, eventKey: 'users', label: 'Users' },
            { to: `${cityBasePath}/history`, eventKey: 'history', label: 'History of changes' },
        ]
        : [
            { to: '/company-edit/:id', eventKey: 'companyInfo', label: 'Company Info' },
            { to: '/company-edit-hiring/:id', eventKey: 'hiringInfo', label: 'Hiring Info' },
            { to: '/company-edit-users/:id', eventKey: 'users', label: 'Users' },
            { to: '/company-edit-history/:id', eventKey: 'history', label: 'History of changes' },
        ];

    const [tickets, setTickets] = useState([]);
    useEffect(() => {
        const fetchTickets = async () => {
            try {
                // ✅ goes through interceptor; token auto-attached
                const res = await api.get('/api/tickets'); // ✅
                setTickets(res.data);
            } catch (error) {
                console.error('Error fetching tickets:', error);
            }   
        };
        fetchTickets();
    }, []);
    
    useEffect(() => {
        console.log(showErrorMessage, 'showErrorMessage updated');
    }, [showErrorMessage]);

    const handleDeleteCompany = () => {
        setShowDeleteModal(true);
    };

    const confirmDeleteCompany = async () => {
        try {
            await api.delete(`/api/companies/${id}`);
            setShowDeleteModal(false);
            navigate('/onboarding-company-list');
        } catch (error) {
            console.error('Error deleting company:', error);
            alert('An error occurred while deleting the company.');
        }
    };
    
    useEffect(() => {
        // Fetch company data for editing
        const fetchCompanyData = async () => {
            try {
                const response = await api.get(`/api/companies/${id}`);
                const companyData = response.data;

                setActivityStatus(companyData.activityStatus ?? false);
                setOriginalLogoUrl(companyData.logo || '');
                setLogoPreview(companyData.logo || '');

                setGeneralData({
                    title: companyData.title || '',
                    url: companyData.url || '',
                    logo: companyData.logo || '',
                    logoPreview: companyData.logo || '',
                    accessLevel: companyData.accessLevel || '',
                    bestPlacetoWorkRating: companyData.bestPlacetoWorkRating || '',
                    bestPlacetoWorkDescription: companyData.bestPlacetoWorkDescription || '',
                    activityStatus: companyData.activityStatus ?? false,
                    createdAt: companyData.created_at || '',
                    updatedAt: companyData.updatedAt || '',
                    accountApprovalStatus: companyData.accountApprovalStatus || '',
                });

                setAboutData({
                    address: companyData.address || '',
                    address2: companyData.address2 || '',
                    country: companyData.country || '',
                    country2: companyData.country2 || '',
                    city: companyData.city || '',
                    city2: companyData.city2 || '',
                    cityRegion: companyData.cityRegion || '',
                    zip: companyData.zip || '',
                    zip2: companyData.zip2 || '',
                    otherInformation: companyData.otherInformation || '',
                    otherInformation2: companyData.otherInformation2 || '',
                    childUrl: companyData.childUrl || '',
                    childUrl2: companyData.childUrl2 || '',
                    phone: companyData.phone || '',
                    phone2: companyData.phone2 || '',
                    latitude: companyData.latitude,
                    longitude: companyData.longitude,
                    latitude2: companyData.latitude2,
                    longitude2: companyData.longitude2,
                    logo: companyData.logo || '',
                    title: companyData.title || '',
                });
                
                setShowAddress2(!!(companyData.address2 || companyData.latitude2 || companyData.longitude2));

                setLegalData({
                    legalName: companyData.legalName || '',
                    vat: companyData.vat || '',
                    duns: companyData.duns || '',
                    globalUltimate: companyData.globalUltimate || '',
                });

                setSizeData({
                    globalSize: companyData.globalSize || '',
                    localSize: companyData.localSize || '',
                    rating: companyData.rating || '',
                    ratingSource: companyData.ratingSource || '',
                });

                setIndustriesData({
                    industries: (companyData.industries || []).map(ind => ({
                        industry: ind.industry || '',
                        subIndustry: Array.isArray(ind.subIndustry) ? ind.subIndustry : [], // ✅ Ensure array
                        subIndustry2: Array.isArray(ind.subIndustry2) ? ind.subIndustry2 : [], // ✅ Ensure array
                    })),
                });

                setBusinessTypeData({
                    businessPurpose: companyData.businessPurpose || '',
                    localActivities: companyData.localActivities || '',
                    localStaffing: companyData.localStaffing || '',
                    businessTypeOther: companyData.businessTypeOther || '',
                });

                setFortuneData({
                    isFortune: companyData.isFortune || false,
                    fortuneRank: companyData.fortuneRank || '',
                    fortuneYear: companyData.fortuneYear || '',
                    fortuneRevenue: companyData.fortuneRevenue || '',
                    fortunePercentChange: companyData.fortunePercentChange || '',
                    fortuneProfit: companyData.fortuneProfit || '',
                });

            } catch (error) {
                console.error('Error fetching company data:', error);
                alert('An error occurred while fetching company details.');
            }
        };

        fetchCompanyData();
    }, [id]);

    const handleGeneralChange = (e) => {
        const { name, value } = e.target;

        // ✅ Handle file separately
        if (name === 'logo' && value instanceof File) {
            setLogo(value);
            const fileUrl = URL.createObjectURL(value);
            setLogoPreview(fileUrl);

            setGeneralData((prevData) => ({
                ...prevData,
                logo: value,
                logoPreview: fileUrl,
            }));
            return;
        }

        setGeneralData((prevData) => ({
            ...prevData,
            [name]: value,
        }));

        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: '',
        }));
    };

    const handleAboutChange = (e) => {
        const { name, value } = e.target;

        setAboutData((prevData) => ({
            ...prevData,
            [name]: value,
        }));

        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: '',
        }));
    };

    const handleLegalChange = (e) => {
        const { name, value } = e.target;

        setLegalData((prevData) => ({
            ...prevData,
            [name]: value,
        }));

        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: '',
        }));
    };

    const handleSizeChange = (e) => {
        const { name, value } = e.target;

        setSizeData((prevData) => ({
            ...prevData,
            [name]: value,
        }));

        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: '',
        }));
    };

    const handleIndustryChange = (index, field, value) => {
        setIndustriesData((prevData) => {
            const updatedIndustries = [...prevData.industries];
    
            if (field === 'subIndustry' || field === 'subIndustry2') {
                updatedIndustries[index][field] = Array.isArray(value) ? value : [value]; // ✅ Ensure array
            } else {
                updatedIndustries[index][field] = value;
            }
    
            return { ...prevData, industries: updatedIndustries };
        });
    };

    const handleAddIndustry = () => {
        setIndustriesData((prevData) => ({
            ...prevData,
            industries: [...prevData.industries, { industry: '', subIndustry: '', subIndustry2: [] }],
        }));
    };

    const handleRemoveIndustry = (indexToRemove) => {
        setIndustriesData((prevData) => ({
            ...prevData,
            industries: prevData.industries.filter((_, index) => index !== indexToRemove),
        }));
    };
    
    const handleAddSubIndustry2 = (index) => {
        setIndustriesData((prevData) => {
            const updatedIndustries = [...prevData.industries];
            updatedIndustries[index].subIndustry2 = [
                ...(updatedIndustries[index].subIndustry2 || []),
                '',
            ];
            return { ...prevData, industries: updatedIndustries };
        });
    };

    const handleBusinessTypeChange = (e) => {
        const { name, value } = e.target;
    
        setBusinessTypeData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: '',
        }));
    };

    const handleBusinessSubmit = async (e) => {
        e.preventDefault();
    
        try {
            await api.put(`/api/companies/${id}/business-type`, businessTypeData);
            setSavedModalTitle('Update successful');
            setSavedModalMessage('Business Type information updated successfully.');
            setShowSavedModal(true);
        } catch (error) {
            console.error('Error updating Business Type information:', error);
            alert('An error occurred while updating Business Type information.');
        }

    };
    
    const handleFortuneSubmit = async (e) => {
        e.preventDefault();
    
        try {
            const payload = {
                ...fortuneData,
                isFortune: !!fortuneData.isFortune, // Ensure it's a boolean
            };
    
            await api.put(
                `/api/companies/${id}/fortune`,
                payload,
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            );
            setSavedModalTitle('Update successful');
            setSavedModalMessage('Fortune 1000 information updated successfully.');
            setShowSavedModal(true);
        } catch (error) {
            console.error('Error updating Fortune information:', error.response || error.message);
            alert('An error occurred while updating Fortune information.');
        }
    };

    const handleFortuneChange = (e) => {
        const { name, value } = e.target;
        setFortuneData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const validateGeneralFields = (inputURL) => {
        const newErrors = {};

        if (!generalData.title.trim()) {
            newErrors.title = 'Company name is required.';
        }

        if (!inputURL) {
            newErrors.url = 'Company website is required.';
        } else {
            const urlPattern = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d+)?(\/.*)?$/;
            if (!urlPattern.test(inputURL)) {
                newErrors.url = 'Please enter a valid URL.';
            }
        }

        setErrors(newErrors);
        console.log('Validation Errors:', newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const validateAboutFields = () => {
        const newErrors = {};
    
        if (!aboutData.address.trim()) {
            newErrors.address = 'Address is required.';
        }
        if (!aboutData.country.trim()) {
            newErrors.country = 'Country is required.';
        }
        if (!aboutData.city.trim()) {
            newErrors.city = 'City is required.';
        }
        if (!aboutData.zip.trim()) {
            newErrors.zip = 'ZIP Code is required.';
        }
        // if (!aboutData.otherInformation.trim()) {
        //     newErrors.otherInformation = 'Other information is required.';
        // }
    
        // `childUrl` is optional, so it won't be validated.
    
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const validateLegalFields = () => {
        const newErrors = {};
    
        if (!legalData.legalName.trim()) {
            newErrors.legalName = 'Legal name is required.';
        }
        if (!legalData.vat.trim()) {
            newErrors.vat = 'VAT number is required.';
        }
    
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleGeneralSubmit = async (e) => {
        if (e) e.preventDefault();

        const form = e.target.closest('form'); // ✅ get the form
        const urlInput = form.querySelector('[name="url"]'); // ✅ get url input
        const inputURL = urlInput ? urlInput.value.trim() : ''; // ✅ get trimmed value

        const isValid = validateGeneralFields(inputURL);
    
        if (!isValid) {
            console.log('Validation failed, preventing submit');
            return false;
        }

        try {
            const data = new FormData();
            Object.keys(generalData).forEach((key) => {
                if (key === 'logo') {
                    if (logo) {
                        data.append('logo', logo);
                    }
                } else {
                    data.append(key, generalData[key]);
                }
            });
            
            const res = await api.put(
                `/api/companies/${id}/general`,
                data,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                }
            );

            const updated = res.data;
            setGeneralData((prev) => ({
                ...prev,
                ...updated,
                logoPreview: updated.logo || '',
            }));
            setLogoPreview(updated.logo || '');
            setLogo(null);
            setSavedModalTitle('Update successful');
            setSavedModalMessage('General company information was updated successfully.');
            setShowSavedModal(true);
            return true;
        } catch (error) {
            console.error('Error updating general information:', error);
            alert('An error occurred while updating general information.');
            return false;
        }
    };

    const handleAboutSubmit = async (e) => {
        e.preventDefault();

        if (!validateAboutFields()) {
            console.log('Validation failed - setting showErrorMessage to true');
            setShowErrorMessage(true);
            return false; // ✅ indicate failure
        }

        try {
            await api.put(
                `/api/companies/${id}/about`,
                aboutData
            );

            setShowErrorMessage(false);
            setSavedModalTitle('Update successful');
            setSavedModalMessage('About company information was updated successfully.');
            setShowSavedModal(true);
            return true; // ✅ indicate success

        } catch (error) {
            console.error('Error updating about information:', error);
            setShowErrorMessage(true);
            alert('An error occurred while updating about information.');
            return false;
        }
    };

    const handleLegalSubmit = async (e) => {
        e.preventDefault();
    
        if (!validateLegalFields()) return;
    
        try {

            await api.put(
                `/api/companies/${id}/legal`,
                legalData
            );
    
            setSavedModalTitle('Update successful');
            setSavedModalMessage('Legal company information was updated successfully.');
            setShowSavedModal(true);
        } catch (error) {
            if (error.response && error.response.data && error.response.data.msg) {
                // Display the error message from the backend
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    vat: error.response.data.msg,
                }));
            } else {
                console.error('Error updating legal information:', error);
                alert('An error occurred while updating legal information.');
            }
        }
    };

    const handleSizeSubmit = async (e) => {
        e.preventDefault();
    
        try {
            await api.put(
                `/api/companies/${id}/size`,
                sizeData
            );
            setSavedModalTitle('Update successful');
            setSavedModalMessage('Size information updated successfully.');
            setShowSavedModal(true);
        } catch (error) {
            if (error.response && error.response.data && error.response.data.msg) {
                // Display the error message from the backend
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    vat: error.response.data.msg,
                }));
            } else {
                console.error('Error updating size information:', error);
                alert('An error occurred while updating size information.');
            }
        }
    };

    const handleIndustriesSubmit = async (e) => {
        e.preventDefault();

        try {
            const payload = {
                industries: JSON.stringify(
                    industriesData.industries.filter(ind => ind.industry?.trim()).map(ind => ({
                        industry: ind.industry,
                        subIndustry: Array.isArray(ind.subIndustry) ? ind.subIndustry : [],
                        subIndustry2: Array.isArray(ind.subIndustry2) ? ind.subIndustry2 : [],
                    }))
                ),
            };

            await api.put(
                `/api/companies/${id}/industries`,
                payload
            );
            
            setSavedModalTitle('Update successful');
            setSavedModalMessage('Industries information updated successfully.');
            setShowSavedModal(true);
        } catch (error) {
            console.error('Error updating Industries information:', error.response || error.message);
            alert('An error occurred while updating Industries information.');
        }
    };

    const toggleActivityStatus = async () => {
        try {
            const updatedStatus = !activityStatus;

            await api.patch(
                `/api/companies/${id}/activity-status`,
                { activityStatus: updatedStatus },
            );

            setActivityStatus(updatedStatus);
            setStatusMessage(updatedStatus ? "Company Activated" : "Company Deactivated");
            setShowStatusModal(true);
    
            setGeneralData((prevData) => ({
                ...prevData,
                activityStatus: updatedStatus,
            }));
        } catch (error) {
            console.error('Error toggling activity status:', error);
            alert('An error occurred while updating the activity status.');
        }
    };

    if (!user || !isAdminType(user.role)) {
        return <div>You are not authorized to view this page.</div>;
    }

    const handleResetLogo = () => {
        setLogo(null);
        setLogoPreview(originalLogoUrl); // restore saved logo from DB
    };

    const handleDeleteImage = () => {
        setLogo(null);
        setLogoPreview('fallback'); // we'll handle it in the child
        setGeneralData((prev) => ({
            ...prev,
            logo: '',
            logoPreview: 'fallback',
        }));
    };

    const handleExportPdf = async () => {
        try {
            await exportCompanyPdf(id);
        } catch (error) {
            console.error('Error exporting company PDF:', error);
            alert('An error occurred while exporting the company PDF.');
        }
    };

    return (
        <>
            <Sidebar ticketCount={tickets.length} />
            <main className="main-content flex-grow-1">
                <Container>
                    <Row>
                        <Col>
                            {showErrorMessage && (
                                <Alert variant="danger" onClose={() => setShowErrorMessage(false)} dismissible>
                                    <p><strong>Error</strong> - There are items that require your attention</p>
                                </Alert>
                            )}
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Breadcrumb cityName={cityName} companyName={generalData.title} />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Card>
                                <Card.Body className="pt-0">
                                    <Row>
                                        <Col xs={12}>
                                            <>
                                                <Row>
                                                    <Col>
                                                        <Form onSubmit={handleGeneralSubmit}>
                                                            <CompanyAddGeneral
                                                                formData={generalData}
                                                                handleChange={handleGeneralChange}
                                                                logo={generalData.logoPreview}
                                                                errors={errors}
                                                                handleGeneralSubmit={handleGeneralSubmit}
                                                                isEditPage={true}
                                                                activityStatus={activityStatus}
                                                                handleResetLogo={handleResetLogo}
                                                                forceRerenderKey={forceRerenderKey}
                                                                setForceRerenderKey={setForceRerenderKey}
                                                                handleDeleteImage={handleDeleteImage}
                                                                showErrorMessage={showErrorMessage}
                                                                setShowErrorMessage={setShowErrorMessage}
                                                            />
                                                        </Form>
                                                    </Col>
                                                </Row>
                                                <Row className="mb-5">
                                                    <Col>
                                                        <NavTabs items={companyNavItems} />
                                                    </Col>
                                                </Row>
                                                <Row className="mb-5">
                                                    <Col><h2>Company info</h2></Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <CompanyStats 
                                                            createdAt={generalData.createdAt} 
                                                            updatedAt={generalData.updatedAt} 
                                                            accessLevel={generalData.accessLevel} 
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row className="mb-4">
                                                    <Col>
                                                        <Form onSubmit={handleAboutSubmit}>
                                                            <CompanyAddAbout
                                                                formData={aboutData}
                                                                handleChange={handleAboutChange}
                                                                errors={errors}
                                                                setErrors={setErrors}
                                                                handleAboutSubmit={handleAboutSubmit}
                                                                isEditPage={true}
                                                                isEditing={isEditing}
                                                                setIsEditing={setIsEditing}
                                                                showAddress2={showAddress2}
                                                                setShowAddress2={setShowAddress2}
                                                                logo={aboutData.logo}
                                                                validationAttempted={validationAttempted}
                                                                showErrorMessage={showErrorMessage}
                                                                setShowErrorMessage={setShowErrorMessage}
                                                            />
                                                        </Form>
                                                    </Col>
                                                    <Col>
                                                        <Form onSubmit={handleLegalSubmit}>
                                                            <CompanyAddLegal
                                                                formData={legalData}
                                                                handleChange={handleLegalChange}
                                                                errors={errors}
                                                                setErrors={setErrors}
                                                                handleLegalSubmit={handleLegalSubmit}
                                                                isEditPage={true}
                                                                showErrorMessage={showErrorMessage}
                                                                setShowErrorMessage={setShowErrorMessage}
                                                            />
                                                        </Form>
                                                        <Form onSubmit={handleSizeSubmit}>
                                                            <CompanyAddSize
                                                                formData={sizeData}
                                                                handleChange={handleSizeChange}
                                                                errors={errors}
                                                                isEditPage={true}
                                                                handleSizeSubmit={handleSizeSubmit}
                                                            />
                                                        </Form>
                                                    </Col>
                                                </Row>
                                                <Row className="mb-4">
                                                    <Col>
                                                        <Form onSubmit={handleIndustriesSubmit}>
                                                            <CompanyAddIndustries
                                                                industries={industriesData.industries}
                                                                onAddIndustry={handleAddIndustry}
                                                                onRemoveIndustry={handleRemoveIndustry}
                                                                onIndustryChange={handleIndustryChange}
                                                                onAddSubIndustry2={handleAddSubIndustry2}
                                                                isEditPage={true}
                                                                errors={errors}
                                                                handleIndustriesSubmit={handleIndustriesSubmit}
                                                            />
                                                        </Form>
                                                    </Col>
                                                </Row>
                                                <Row className="mb-4">
                                                    <Col>
                                                        <Form onSubmit={handleBusinessSubmit}>
                                                            <CompanyAddBusinessType
                                                                formData={businessTypeData}
                                                                handleChange={handleBusinessTypeChange}
                                                                isEditPage={true}
                                                                handleBusinessSubmit={handleBusinessSubmit}
                                                            />
                                                        </Form>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <Form onSubmit={handleFortuneSubmit}>
                                                            <CompanyAddFortune
                                                                formData={fortuneData}
                                                                handleChange={handleFortuneChange}
                                                                setFormData={setFortuneData}
                                                                isEditPage={true}
                                                                handleFortuneSubmit={handleFortuneSubmit}
                                                            />
                                                        </Form>
                                                    </Col>
                                                </Row>
                                            </>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                    <Row className="buttons-row">
                        <Col>
                            <Button
                                variant="outline-danger"
                                onClick={handleDeleteCompany} 
                                className="px-4"
                            >
                                    Delete
                            </Button>
                            <Button 
                                variant="outline-secondary"
                                onClick={toggleActivityStatus} 
                                className="px-4"
                            >
                                {activityStatus ? "Deactivate" : "Activate"}
                            </Button>
                            <Button variant="outline-secondary" onClick={handleExportPdf}>
                                Download company report
                            </Button>
                        </Col>
                    </Row>
                </Container>
            </main>

            {/* Delete Confirmation Modal */}
            <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Delete</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Are you sure you want to delete this company? This action cannot be undone.</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="outline-secondary me-3"
                        onClick={() => setShowDeleteModal(false)}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="outline-danger"
                        onClick={confirmDeleteCompany} 
                        className=""
                    >
                            Delete
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Activity Status Modal */}
            <Modal show={showStatusModal} onHide={() => setShowStatusModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Status Update</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>{statusMessage}</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={() => setShowStatusModal(false)}>OK</Button>
                </Modal.Footer>
            </Modal>

            {/* Saved info Modal */}
            <Modal show={showSavedModal} onHide={() => setShowSavedModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Image
                        src={icSucess}
                        alt=""
                        className="d-block m-auto mb-4"
                    />
                    <h2 className="text-center mb-3">{savedModalTitle}</h2>
                    <p className="text-center">{savedModalMessage}</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={() => setShowSavedModal(false)}>OK</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default EditCompanyGeneral;
